import { useEffect, useState } from "react";

import { useGetLoggedIn }                          from "_common/hooks/auth";
import { useGetDeviceType, useGetUserCountryCode } from "_common/hooks/global";
import toast                                       from "_common/toast";
import { getCreatorPlusPlans, getUserPlusPlan }    from "_services/api/creator-plus";

import Presentation       from "./presentation";
import { useSetUserPlan } from "./states";

const plusPacks = plans => {

	return plans?.plans?.map ( ( item, index ) => {
		return {
			packId             : item.id,
			day                : item.validity,
			amount             : item.amount,
			currency           : item.currency,
			defaultSelected    : index === 0,
			variationId        : item.variationId,
			metadata           : item.metadata || {},
			showDownloadBtn    : !!item.app_installs,
			currencyIcon       : item.currency_icon || "₹",
			isPopular          : false,
			type               : item?.design,
			wallet             : item?.wallet,
			discountedAmount   : item.amount,
			isSubscriptionPlan : false
		};
	} );
};

const component = ( {
	initialOpen,
	plans = [],
	from,
	isProStatus,
	proDetails,
	emotionCache,
	error,
	isWebView
} ) => {
	const [ proPlans, setProPlans ] = useState ( [] );
	const [ userPlan, setUserPlan ] = useState ( proDetails );
	const _setUserPlan              = useSetUserPlan ();

	const deviceType  = useGetDeviceType ();
	const isMobile    = deviceType === "mobile";
	const countryCode = useGetUserCountryCode ();
	const isLoggedIn  = useGetLoggedIn ();

	useEffect ( () => {
		if ( proDetails || !isLoggedIn ) {
			_setUserPlan ( proDetails );

			return;
		}

		fetchCurrentPlan ();
	}, [] );

	useEffect ( () => {
		if ( plans?.length )
			return;
		fetchCreatorPlusPlans ();
	}, [] );

	const fetchCurrentPlan = async () => {
		try {
			const response = await getUserPlusPlan ();

			setUserPlan ( response );
			_setUserPlan ( response );
		} catch ( err ) {
			toast.error ( err.displayMsg );
		}
	};

	const fetchCreatorPlusPlans = async () => {
		try {
			const response = await getCreatorPlusPlans ( { countryCode, screen: "plusModalPage" } );

			setProPlans ( response );
		} catch ( err ) {
			toast.error ( err.displayMsg );
		}
	};

	const packs = plusPacks ( plans?.plans?.length > 0 ? plans : proPlans );

	let hasSubscription = false;

	/* if ( userPlan?.upcomingPlan ) {
		hasSubscription = true;
	} else if ( userPlan?.subscriptionStatus === "SUCCESS" ) {
		hasSubscription = true;
	} */

	return (
		<Presentation
			emotionCache     = { emotionCache }
			error            = { error }
			from             = { from }
			hasSubscription  = { hasSubscription }
			initialOpen      = { initialOpen }
			isMobile         = { isMobile }
			isProServer      = { isProStatus }
			isWebView        = { isWebView }
			plusPacks        = { packs }
			userPlan         = { userPlan }
		/>
	);
};

export default component;
